<app-layout [dir]="textDir" [languageList]="languageList" [templateType]="layoutTemplateType"></app-layout>
<app-loader *ngIf="loaderService.isLoading(loaderEnum.MAIN)" [id]="loaderEnum.MAIN" backdrop-position="relative"></app-loader>
